import axios from "axios";

export const lookupLakes = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Lookup/lakes`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
